export const init = () => {
  /* SHOPPING TOOL - CAROUSEL CATEGORY */

  if (tc_vars.env_template !== 'list') return;

  const fwk = CUBE.Analytics;

  const stType = 'navigation-carousel-category';

  // CSS Selector : 'carousel category'
  const carouselSelector = '#product-list-categories';

  // NAVIGATION Carousel-Category
  $(carouselSelector).on('click.st', '.category.slick-slide', function() {
    const categoryName = $(this)
      .find('h3.title')
      .text()
      .trim()
      .toLowerCase()
      .split(' ')
      .join('-');

    fwk.shoppingtool.set(stType, categoryName);
  });
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-carousel-category.js